module.exports = __webpack_public_path__ + "media/images/recruit/top/copy-7d9b10e909458512b3688ec241f068e4.png";